/* created by Athukorala */

import * as actionTypes from '../Action/actionTypes';

const initialState = {
  is_spin: false
};

const reducer=(state=initialState,action)=>{
  switch(action.type){


    case actionTypes.SPINNER:
      return {
        ...state,
        is_spin: action.value
      };

    default:
      return state;
  }
};

export default reducer;
